import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { AssetsType } from 'src/app/constants/assetsType';
import { map, startWith } from 'rxjs/operators';
import { AssetsService } from 'src/app/services/assets.service';

@Component({
  selector: 'app-update-assets',
  templateUrl: './update-assets.component.html',
  styleUrls: ['./update-assets.component.css'],
})
export class UpdateAssetsComponent implements OnInit {
  assetsList = AssetsType;
  selectUpdateCategory: string;
  selectedAsset: string;
  selectedAssetDescription: string;
  employeeName: any[] = [];
  assetType;
  disableBtn = false;
  assetId: any;
  successFlag = false;
  empName: any;
  filterEmpName: string;
  description: string;
  fileList = 'assets';
  searchAssetId: string;
  assetCategory: any;
  errorFlag = false;

  constructor(
    private fb: UntypedFormBuilder,
    private assetsService: AssetsService,
  ) {}

  ngOnInit(): void {
    this.watchAssignDateChanges();
    // keep insurance/warranty controls in sync like new-asset
    this.updateAssetForm
      .get('insurance')
      ?.valueChanges.subscribe(() => this.updateInsuranceWarrantyValidators());
    this.updateAssetForm
      .get('warranty')
      ?.valueChanges.subscribe(() => this.updateInsuranceWarrantyValidators());
  }

  private updateInsuranceWarrantyValidators(): void {
    const insuStartControl = this.updateAssetForm.get('insuStartDate');
    const insuEndControl = this.updateAssetForm.get('insuEndDate');
    const warStartControl = this.updateAssetForm.get('warStartDate');
    const warEndControl = this.updateAssetForm.get('warEndDate');

    if (this.updateAssetForm.get('insurance')?.value) {
      insuStartControl?.setValidators([Validators.required]);
      insuEndControl?.setValidators([Validators.required]);
    } else {
      insuStartControl?.clearValidators();
      insuEndControl?.clearValidators();
    }

    if (this.updateAssetForm.get('warranty')?.value) {
      warStartControl?.setValidators([Validators.required]);
      warEndControl?.setValidators([Validators.required]);
    } else {
      warStartControl?.clearValidators();
      warEndControl?.clearValidators();
    }

    insuStartControl?.updateValueAndValidity({ emitEvent: false });
    insuEndControl?.updateValueAndValidity({ emitEvent: false });
    warStartControl?.updateValueAndValidity({ emitEvent: false });
    warEndControl?.updateValueAndValidity({ emitEvent: false });
  }

  private watchAssignDateChanges(): void {
    const currentStartControl = this.updateAssetForm.get('empAssignedDate');
    const currentEndControl = this.updateAssetForm.get('currentEmpEndDate');
    const newStartControl = this.updateAssetForm.get('newEmpAssignedDate');

    currentStartControl?.valueChanges.subscribe(() => this.validateDateOrder());
    currentEndControl?.valueChanges.subscribe(() => this.validateDateOrder());
    newStartControl?.valueChanges.subscribe(() => this.validateDateOrder());
  }

  private validateDateOrder(): void {
    const currentStartControl = this.updateAssetForm.get('empAssignedDate');
    const currentEndControl = this.updateAssetForm.get('currentEmpEndDate');
    const newStartControl = this.updateAssetForm.get('newEmpAssignedDate');

    if (!currentStartControl || !currentEndControl || !newStartControl) {
      return;
    }

    this.clearControlError(currentEndControl, 'dateOrder');
    this.clearControlError(newStartControl, 'dateOrder');

    const currentStart = currentStartControl.value;
    const currentEnd = currentEndControl.value;
    const newStart = newStartControl.value;
    if (!currentStart || !currentEnd || !newStart) {
      return;
    }

    const currentStartTime = this.toDate(currentStart).getTime();
    const currentEndTime = this.toDate(currentEnd).getTime();
    const newStartTime = this.toDate(newStart).getTime();

    if (currentEndTime <= currentStartTime) {
      currentEndControl.setErrors({
        ...currentEndControl.errors,
        dateOrder: true,
      });
    } else if (newStartTime <= currentEndTime) {
      newStartControl.setErrors({
        ...newStartControl.errors,
        dateOrder: true,
      });
    }
  }

  private clearControlError(control: any, errorKey: string): void {
    const currentErrors = control.errors;
    if (!currentErrors || !currentErrors[errorKey]) {
      return;
    }
    const updatedErrors = { ...currentErrors };
    delete updatedErrors[errorKey];
    control.setErrors(Object.keys(updatedErrors).length ? updatedErrors : null);
  }

  updateCarAsset() {
    const formData: any = this.updateAssetForm.value;
    this.successFlag = false;
    const carAsset = {
      assetId: formData.assetId,
      comments: formData.assetCar.assetComments,
      model: formData.assetCar.model,
      make: formData.assetCar.make,
      number: formData.assetCar.number,
      color: formData.assetCar.color,
      chasisNumber: formData.assetCar.chasisNumber,
      carbonEmission: formData.assetCar.carbonEmission,
      cataloguePrice: formData.assetCar.cataloguePrice,
      assetCategory: formData.assetCar.assetCategory,
      leaseEndDate: formData.assetCar.leaseEndDate,
      fuelType: formData.assetCar.fuelType,
      assetStartDate: formData.assetStartDate,
      assetEndDate: formData.assetEndDate,
      insurance: formData.insurance,
      warranty: formData.warranty,
      insuStartDate: formData.insuStartDate,
      insuEndDate: formData.insuEndDate,
      warStartDate: formData.warStartDate,
      warEndDate: formData.warEndDate,
    };
    this.assetsService.updateCarAsset(carAsset).subscribe((res) => {
      console.log(res);
      this.successFlag = true;
      if (res.responseStatus == 'Failure') {
        this.errorFlag = true;
        this.description = res.errorDescription;
      } else {
        this.errorFlag = false;
        this.updateAssetForm.reset();
        this.description = 'Asset Updated Successfully';
      }
    });
  }

  updateElectronicAsset() {
    const formData: any = this.updateAssetForm.value;
    this.successFlag = false;
    const electronucAsset = {
      assetId: formData.assetId,
      electronicModel: formData.assetElectronic.electronicModel,
      electronicSerialNumber: formData.assetElectronic.electronicSerialNumber,
      electronicPrice: formData.assetElectronic.electronicPrice,
      comments: formData.assetElectronic.assetComments,
      assetStartDate: formData.assetStartDate,
      assetEndDate: formData.assetEndDate,
      insurance: formData.insurance,
      warranty: formData.warranty,
      insuStartDate: formData.insuStartDate,
      insuEndDate: formData.insuEndDate,
      warStartDate: formData.warStartDate,
      warEndDate: formData.warEndDate,
    };
    this.assetsService
      .updateElectronicAsset(electronucAsset)
      .subscribe((res) => {
        console.log(res);
        if (res.responseStatus == 'Failure') {
          this.errorFlag = true;
          this.description = res.errorDescription;
        } else {
          this.successFlag = true;
          this.description = 'Asset Updated Successfully';
          this.updateAssetForm.reset();
        }
      });
  }

  assignAsset() {
    this.successFlag = false;
    this.errorFlag = false;
    const formData: any = this.updateAssetForm.value;
    this.description = '';
    const assignAsset = {
      assetId: formData.assetId,
      empAssignedDate: formData.empAssignedDate,
      currentEmpEndDate: formData.currentEmpEndDate,
      newEmpAssignedDate: formData.newEmpAssignedDate,
      comments: formData.comments,
      assetAssignedToEmp: this.empName,
      status: formData.status,
      empAssetId: formData.empAssetId,
    };

    const currentEndControl = this.updateAssetForm.get('currentEmpEndDate');
    const newStartControl = this.updateAssetForm.get('newEmpAssignedDate');
    const currentStartControl = this.updateAssetForm.get('empAssignedDate');

    this.clearControlError(currentEndControl, 'dateOrder');
    this.clearControlError(newStartControl, 'dateOrder');

    if (
      !assignAsset.currentEmpEndDate ||
      !assignAsset.newEmpAssignedDate ||
      !assignAsset.assetAssignedToEmp
    ) {
      this.errorFlag = true;
      this.description = 'Please select all mandatory fields';
    } else if (
      this.toDate(assignAsset.currentEmpEndDate).getTime() <=
      this.toDate(assignAsset.empAssignedDate).getTime()
    ) {
      this.errorFlag = true;
      currentEndControl?.setErrors({ dateOrder: true });
      this.description =
        'Current employee end date must be later than current employee start date';
    } else if (
      this.toDate(assignAsset.newEmpAssignedDate).getTime() <=
      this.toDate(assignAsset.currentEmpEndDate).getTime()
    ) {
      this.errorFlag = true;
      newStartControl?.setErrors({ dateOrder: true });
      this.description =
        'New employee assign date must be later than current employee end date';
    } else {
      this.assetsService.assignAsset(assignAsset).subscribe((res) => {
        console.log(res);
        if (res.responseStatus == 'Failure') {
          this.errorFlag = true;
          this.description = res.errorDescription;
        } else {
          this.successFlag = true;
          this.description = 'Asset ' + res.assetId + ' Updated Successfully';
          this.updateAssetForm.reset({ updateCategory: 'assignEmp' });
          this.empName = null;
          this.assetType = '';
          this.assetCategory = null;
          this.searchAssetId = '';
          this.selectUpdateCategory = 'assignEmp';
        }
      });
    }
  }

  searchAsset($event: Event) {
    this.successFlag = false;
    this.searchAssetId = ($event.target as HTMLTextAreaElement).value;
    if (this.searchAssetId != '') {
      // this.updateAssetForm.reset();
      this.assetsService.fetchAsset(this.searchAssetId).subscribe((res) => {
        console.log('API Response ==========> ', res);
        this.assetType = res.assetType;
        this.selectedAsset = res.assetType;
        //this.filterEmpName = res.assetAssignedToEmp
        this.updateAssetForm.patchValue({
          assetId: res.assetId,
          assetType: res.assetType,
          empAssignedDate: this.parseDateString(res.empAssignedDate),
          currentEmpEndDate: this.parseDateString(
            res.currentEmpEndDate || res.empEndDate,
          ),
          comments: res.empCommnets,
          mobileNumber: res.mobileNumber,
          fuelCard: res.fuelCard,
          empAssetId: res.empAssetId,
          currentEmp: res.assetAssignedToEmp,
          status: res.status,
          assetStartDate: this.parseDateString(res.assetStartDate),
          assetEndDate: this.parseDateString(res.assetEndDate),
          insurance: res.insurance,
          warranty: res.warranty,
          insuStartDate: this.parseDateString(res.insuStartDate),
          insuEndDate: this.parseDateString(res.insuEndDate),
          warStartDate: this.parseDateString(res.warStartDate),
          warEndDate: this.parseDateString(res.warEndDate),
          assetCar: {
            model: res.model,
            make: res.make,
            number: res.number,
            color: res.color,
            chasisNumber: res.chasisNumber,
            carbonEmission: res.carbonEmission,
            cataloguePrice: res.cataloguePrice,
            assetCategory: res.assetCategory,
            leaseEndDate: this.parseDateString(res.leaseEndDate),
            fuelType: res.fuelType,
          },
          assetElectronic: {
            electronicModel: res.electronicModel,
            electronicSerialNumber: res.electronicSerialNumber,
            electronicPrice: res.electronicPrice,
          },
        });
        this.assetCategory = res.assetCategory;
        console.log(
          'Form values after patch ==========> ',
          this.updateAssetForm.value,
        );
      });
    }
  }

  onSelectionChange(event: any) {
    let asset = event.target.value;
    this.assetType = asset;
  }

  empNameSelected(emp: any) {
    this.empName = emp;
  }

  get isAssignFormValid(): boolean {
    const currentStart = this.updateAssetForm.get('empAssignedDate')?.value;
    const currentEnd = this.updateAssetForm.get('currentEmpEndDate')?.value;
    const newStart = this.updateAssetForm.get('newEmpAssignedDate')?.value;
    const status = this.updateAssetForm.get('status')?.value;
    const empAssetId = this.updateAssetForm.get('empAssetId')?.value;
    const assetId = this.updateAssetForm.get('assetId')?.value;

    if (
      !assetId ||
      !currentStart ||
      !currentEnd ||
      !newStart ||
      !status ||
      !empAssetId ||
      !this.empName
    ) {
      return false;
    }

    const currentStartTime = this.toDate(currentStart).getTime();
    const currentEndTime = this.toDate(currentEnd).getTime();
    const newStartTime = this.toDate(newStart).getTime();

    return currentEndTime > currentStartTime && newStartTime > currentEndTime;
  }

  get isUpdateFormValid(): boolean {
    const assetId = this.updateAssetForm.get('assetId')?.value;
    const assetType = this.updateAssetForm.get('assetType')?.value;
    const assetStartDate = this.updateAssetForm.get('assetStartDate')?.value;
    const insurance = this.updateAssetForm.get('insurance')?.value;
    const warranty = this.updateAssetForm.get('warranty')?.value;
    const insuStartDate = this.updateAssetForm.get('insuStartDate')?.value;
    const insuEndDate = this.updateAssetForm.get('insuEndDate')?.value;
    const warStartDate = this.updateAssetForm.get('warStartDate')?.value;
    const warEndDate = this.updateAssetForm.get('warEndDate')?.value;

    // Basic required fields for update
    if (!assetId || !assetType || !assetStartDate) {
      return false;
    }

    // Check insurance dates if insurance checkbox is checked
    if (insurance && (!insuStartDate || !insuEndDate)) {
      return false;
    }

    // Check warranty dates if warranty checkbox is checked
    if (warranty && (!warStartDate || !warEndDate)) {
      return false;
    }

    // Check car-specific fields if asset type is Car
    if (assetType === 'Car' || assetType === 'car') {
      const carGroup = this.updateAssetForm.get('assetCar');
      if (!carGroup) return false;
      const model = carGroup.get('model')?.value;
      const make = carGroup.get('make')?.value;
      const number = carGroup.get('number')?.value;
      const color = carGroup.get('color')?.value;
      const chasisNumber = carGroup.get('chasisNumber')?.value;
      const cataloguePrice = carGroup.get('cataloguePrice')?.value;
      const assetCategory = carGroup.get('assetCategory')?.value;
      if (
        !model ||
        !make ||
        !number ||
        !color ||
        !chasisNumber ||
        !cataloguePrice ||
        !assetCategory
      ) {
        return false;
      }
    }

    // Check electronic-specific fields if asset type is electronic device
    if (
      assetType === 'Laptop' ||
      assetType === 'Monitor' ||
      assetType === 'Mobile' ||
      assetType === 'Other'
    ) {
      const electronicGroup = this.updateAssetForm.get('assetElectronic');
      if (!electronicGroup) return false;
      const model = electronicGroup.get('electronicModel')?.value;
      const serialNumber = electronicGroup.get('electronicSerialNumber')?.value;
      const price = electronicGroup.get('electronicPrice')?.value;
      if (!model || !serialNumber || !price) {
        return false;
      }
    }

    return true;
  }

  private toDate(value: any): Date {
    return value instanceof Date ? value : new Date(value);
  }

  private parseDateString(value: any): Date | null {
    if (!value) {
      return null;
    }

    if (value instanceof Date) {
      return value;
    }

    const dateString = String(value).trim();
    const parts = dateString.split('/');
    if (parts.length === 3) {
      const day = Number(parts[0]);
      const month = Number(parts[1]) - 1;
      const year = Number(parts[2]);
      // create date at midday to avoid timezone offset shifting the day
      const parsed = new Date(year, month, day, 12, 0, 0, 0);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    }

    const fallback = new Date(dateString);
    return Number.isNaN(fallback.getTime()) ? null : fallback;
  }

  onSubmit() {
    this.successFlag = false;
    console.log(this.updateAssetForm.value);
    this.updateAssetForm.patchValue({
      assetAssignedToEmp: this.empName,
    });
    const assetJson = JSON.stringify(this.updateAssetForm.value);
    console.log('assetJson ' + assetJson);
    const headers = { 'Content-type': 'application/json' };

    this.assetsService.createAsset(assetJson).subscribe((data) => {
      console.log('data ==========> ' + data);
      this.assetId = data.assetId;
      if (data.responseStatus == 'Failure') {
        this.errorFlag = true;
        this.successFlag = false;
        this.description = data.errorDescription;
      } else {
        this.successFlag = true;
        this.errorFlag = false;
        this.description = 'Asset Updated Successfully';
        this.updateAssetForm.reset();
        this.empName = null;
        this.assetType = '';
        this.assetCategory = null;
        this.selectUpdateCategory = '';
      }
    });
  }

  updateAssetForm = this.fb.group({
    assetId: ['', Validators.required],
    assetType: [''],
    assetStartDate: ['', Validators.required],
    assetEndDate: [''],
    insurance: [false],
    insuStartDate: [''],
    insuEndDate: [''],
    warranty: [false],
    warStartDate: [''],
    warEndDate: [''],
    updateCategory: ['', Validators.required],
    empAssignedDate: ['', Validators.required],
    currentEmpEndDate: ['', Validators.required],
    newEmpAssignedDate: ['', Validators.required],
    currentEmp: [''],
    empAssetId: ['', Validators.required],
    status: ['', Validators.required],
    comments: [''],
    mobileNumber: ['', Validators.required],
    fuelCard: ['', Validators.required],
    assetCar: this.fb.group({
      model: ['', Validators.required],
      make: ['', Validators.required],
      number: ['', Validators.required],
      color: ['', Validators.required],
      chasisNumber: ['', Validators.required],
      carbonEmission: [],
      fuelType: [''],
      cataloguePrice: ['', Validators.required],
      assetCategory: ['', Validators.required],
      leaseEndDate: [''],
      assetComments: [],
    }),
    assetElectronic: this.fb.group({
      electronicModel: ['', Validators.required],
      electronicSerialNumber: ['', Validators.required],
      electronicPrice: ['', Validators.required],
      assetComments: [],
    }),
  });
}
